import * as React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

export default function SkeletonLoading({
  width = "100%",
  numberOfItems = 1,
  heightItem = "50px",
}) {
  const items = new Array(numberOfItems).fill(1);
  const hasItems = !!items && items.length > 0;
  return (
    <Box sx={{ width: width }}>
      {hasItems &&
        items.map((item, index) => {
          return (
            <Skeleton
              height={heightItem}
              key={`skeleton-loading-item--${index}`}
              animation="wave"
            />
          );
        })}
    </Box>
  );
}
